import React, { Fragment } from 'react';
import {
  Button,
  Card,
  Box,
  Grid,
  Typography,
  useTheme,
  styled,
  Avatar,
  Divider,
  alpha,
  ListItem,
  ListItemText,
  List,
  ListItemAvatar,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@mui/material';
import TrendingUp from '@mui/icons-material/TrendingUp';
import Text from 'src/components/Text';
import TrendingDown from '@mui/icons-material/TrendingDown';
import {
  ESCALATED_COLOR_VALUE,
  MODERATE_COLOR_VALUE,
  NORMAL_COLOR_VALUE
} from 'src/utils/constants';
import { TableHead } from '@aws-amplify/ui-react';
import { calculateBgColor } from 'src/utils/helpers';
import { ApiError } from 'src/API/types/types';
type OtherInfo = {
  label: string;
  description: string;
};
type Props = {
  errorMessage?: string;
  retryCallBack?: () => void;
};
export function isError<T>(value: T | ApiError): value is ApiError {
  return (value as ApiError)?.errorMessage !== undefined;
}
export const ErrorPlaceHolder = ({ errorMessage, retryCallBack }: Props) => {
  const theme = useTheme();
  return (
    <>
      <Grid item xs={12} md={12} padding={1}>
        <Grid>
          <Card>
            <Box p={1}>
              <Typography variant="h4">{errorMessage}</Typography>
            </Box>
            {retryCallBack && (
              <Box p={1}>
                <Button onClick={() => retryCallBack()}>Retry</Button>
              </Box>
            )}
          </Card>
        </Grid>
      </Grid>
    </>
  );
};
